<div class="novelist-wrapper">
  @if (noData) {
    <div class="no-content flex-row flex-center-center">
      <span>No related content available for this item</span>
    </div>
  } @else {
    <div [attr.data-novelist-novelistselect]="catalogRecord.identifier"></div>
  }
</div>
